import axios from '@/plugins/axios'

export const getCollectionAnalytics = (collectionId, params) =>
  axios.get(`/v1/collections/${collectionId}/analytics`, { params })

export const getCollectionItemAnalytics = (collectionId, itemId, params) =>
  axios.get(`/v1/collections/${collectionId}/analytics/items/${itemId}`, { params })

// Fire-and-forget public view beacon (collection view, or item detail view when itemId is set).
// The server validates the target, dedups per visitor identity and excludes owners/members.
// withCredentials lets the server's visitor cookie round-trip (a no-op while that flag is off).
export const trackPublicView = data => axios.post('/v1/public/track', data, { withCredentials: true })

// Teaser-impression beacon — same endpoint and dedup; `teaser: true` counts an impression instead of
// a view. Pass { collectionId } for a collection card, { collectionId, itemId } for an item card.
export const trackPublicTeaser = data =>
  axios.post('/v1/public/track', { ...data, teaser: true }, { withCredentials: true })
